// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.main-grid-item {
  /* border: 1px solid blue; */
  display: flex;
  flex-direction: column !important;
  gap: 0.5vw;
  /* width: 345px !important; */
}

.select-header {
  font-size: 1.5vw !important;
  font-family: "Poppins" !important;
  font-weight: 500 !important;
}

.select-header-create {
  font-size: 1.3vw !important;
  font-family: "Poppins" !important;
  font-weight: 500 !important;
}

.input-field {
  border: 1.5px solid #000 !important;
  /* width: 20vw !important; */
  height: 6.89vh !important;
  border-radius: 5px !important;
  outline: none !important;
  color: #000 !important;
  font-family: karla !important;
  font-weight: 500 !important;
  font-size: 1.1vw !important;
  padding-right: 0.2vw !important;
}

.input-field .MuiOutlinedInput-notchedOutline {
  border: none !important; /* remove default outline */
}

.input-field.Mui-focused .MuiOutlinedInput-notchedOutline {
  border: none !important; /* remove blue border on focus */
}

.comment-box {
  height: 30vh;
  border-radius: 5px;
  color: #000 !important;
  font-family: karla !important;
  font-weight: 500 !important;
  font-size: 1.1vw !important;
  padding: 0.8vw;
  max-height: 20.8vh;
  overflow: auto;
  scrollbar-width: none;
  resize: none;
  outline: none;
  border: 1.5px solid black;
}
`, "",{"version":3,"sources":["webpack://./src/components/ui/CreateModal/createprojectmodal.css"],"names":[],"mappings":"AAAA;EACE,4BAA4B;EAC5B,aAAa;EACb,iCAAiC;EACjC,UAAU;EACV,6BAA6B;AAC/B;;AAEA;EACE,2BAA2B;EAC3B,iCAAiC;EACjC,2BAA2B;AAC7B;;AAEA;EACE,2BAA2B;EAC3B,iCAAiC;EACjC,2BAA2B;AAC7B;;AAEA;EACE,mCAAmC;EACnC,4BAA4B;EAC5B,yBAAyB;EACzB,6BAA6B;EAC7B,wBAAwB;EACxB,sBAAsB;EACtB,6BAA6B;EAC7B,2BAA2B;EAC3B,2BAA2B;EAC3B,+BAA+B;AACjC;;AAEA;EACE,uBAAuB,EAAE,2BAA2B;AACtD;;AAEA;EACE,uBAAuB,EAAE,gCAAgC;AAC3D;;AAEA;EACE,YAAY;EACZ,kBAAkB;EAClB,sBAAsB;EACtB,6BAA6B;EAC7B,2BAA2B;EAC3B,2BAA2B;EAC3B,cAAc;EACd,kBAAkB;EAClB,cAAc;EACd,qBAAqB;EACrB,YAAY;EACZ,aAAa;EACb,yBAAyB;AAC3B","sourcesContent":[".main-grid-item {\n  /* border: 1px solid blue; */\n  display: flex;\n  flex-direction: column !important;\n  gap: 0.5vw;\n  /* width: 345px !important; */\n}\n\n.select-header {\n  font-size: 1.5vw !important;\n  font-family: \"Poppins\" !important;\n  font-weight: 500 !important;\n}\n\n.select-header-create {\n  font-size: 1.3vw !important;\n  font-family: \"Poppins\" !important;\n  font-weight: 500 !important;\n}\n\n.input-field {\n  border: 1.5px solid #000 !important;\n  /* width: 20vw !important; */\n  height: 6.89vh !important;\n  border-radius: 5px !important;\n  outline: none !important;\n  color: #000 !important;\n  font-family: karla !important;\n  font-weight: 500 !important;\n  font-size: 1.1vw !important;\n  padding-right: 0.2vw !important;\n}\n\n.input-field .MuiOutlinedInput-notchedOutline {\n  border: none !important; /* remove default outline */\n}\n\n.input-field.Mui-focused .MuiOutlinedInput-notchedOutline {\n  border: none !important; /* remove blue border on focus */\n}\n\n.comment-box {\n  height: 30vh;\n  border-radius: 5px;\n  color: #000 !important;\n  font-family: karla !important;\n  font-weight: 500 !important;\n  font-size: 1.1vw !important;\n  padding: 0.8vw;\n  max-height: 20.8vh;\n  overflow: auto;\n  scrollbar-width: none;\n  resize: none;\n  outline: none;\n  border: 1.5px solid black;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
